export const clearStepFormStorage = () => {
  try {
    localStorage.removeItem("selectedInterests");
    localStorage.removeItem("selectedPersonality");
    localStorage.removeItem("formStep0");
    localStorage.removeItem("formStep1");
    localStorage.removeItem("formStep2");
    localStorage.removeItem("formStep3");
  } catch (error) {
    console.error("Error clearing onboarding step data:", error);
  }
};
